import { jsx as _jsx } from "react/jsx-runtime";
import { VariantTableCellLink } from '../../components';
const createTableVariantLink = ({ referrerData: referrerDataProp, additionalData, traitsType, }) => (function TableVariantLink(_, rowData) {
    if (!rowData) {
        throw new Error('No rowData was provided for variant link!');
    }
    let { variant: { id: variantId, name: variantName, } = {}, } = rowData;
    /**
     * Since QV has different format of data, this block checks mapping for QV data
     * @todo Remove after consistent models replacement for QV
     */
    const { variant_id: QVariantId, variant_name: QVariantName, } = rowData;
    if (!variantId && QVariantId) {
        variantId = QVariantId;
    }
    if (!variantName && QVariantName) {
        variantName = QVariantName;
    }
    const { datasetVersionId } = (additionalData !== null && additionalData !== void 0 ? additionalData : {});
    if (!variantId || !datasetVersionId) {
        throw new Error('Not enough data to build valid route for VariantTableCellLink');
    }
    const routeParams = {
        variantId,
        variantName: variantName || '',
        datasetVersionId,
        traitsType,
    };
    const referrerData = Object.assign(Object.assign({}, referrerDataProp), { variantName,
        variantId });
    return (_jsx(VariantTableCellLink, { label: variantName !== null && variantName !== void 0 ? variantName : 'variant', routeParams: routeParams, referrerData: referrerData }, void 0));
});
export default createTableVariantLink;
